import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import Loader from "../components/common/Loader";
import FinanceError from "../components/errors/FinanceError";
import { findConfigAsProperty, findOneConfig } from "./api/condominium";
import handleErrorMessage from "./errors/handleErrorMessage";

export const RouteWithoutAuth = ({ component: Component, ...rest }) => {
  const { isLogged } = useSelector((state) => state.auth);

  if (isLogged) return <Redirect to="/" />;

  return <Route {...rest} component={Component} />;
};

export const ProtectedRoute = ({ rols, component: Component, ...rest }) => {
  const { isLogged, user } = useSelector((state) => state?.auth);
  if (!isLogged) return <Redirect to="/authentication/login" />;
  if (!user) return <Redirect to="/" />;
  if (rols.indexOf(user.role) === -1) return <Redirect to="/" />;
  return <Route {...rest} component={Component} />;
};

export const FinanceRouteProtected = ({
  rols,
  component: Component,
  ...rest
}) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { role } = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(true);

  const [configSetted, setConfigSetted] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (selectedCondominium) {
      if (role === "manager") {
        const getConfig = async () => {
          try {
            const { data } = await findOneConfig(selectedCondominium);
            if (isMounted) {
              if (data.automatic !== null) setConfigSetted(true);
              setLoading(false);
            }
          } catch (error) {
            handleErrorMessage(error);
          }
        };
        getConfig();
      }
      if (role === "property") {
        const getConfig = async () => {
          try {
            const { data } = await findConfigAsProperty(selectedCondominium);
            if (isMounted) {
              if (data.automatic !== null) setConfigSetted(true);
              setLoading(false);
            }
          } catch (error) {
            handleErrorMessage(error);
          }
        };
        getConfig();
      }
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [selectedCondominium]);

  return (
    <Route
      {...rest}
      render={(props) =>
        configSetted ? (
          !loading ? (
            <Component {...props} />
          ) : (
            <Card>
              <Loader padding="py-5" />
            </Card>
          )
        ) : loading ? (
          <Card>
            <CardBody>
              <Row>
                <Col className="d-flex justify-content-center align-items-center">
                  <h5 className="font-weight-bolder">
                    Obteniendo configuración...
                  </h5>
                </Col>
              </Row>
              <Loader padding="py-5" />
            </CardBody>
          </Card>
        ) : (
          <FinanceError role={role} />
        )
      }
    />
  );
};
